"use client";

import { ProductListingRow } from "@/components/features/listings/product-listing-row";
import { cn } from "@/lib/utils";
import type { BrowserListing } from "./listing-filters";

export function ListingResultsGrid({
  cards,
  highlightedId,
  onHoverCard,
  firstIsLcp,
}: {
  cards: readonly BrowserListing[];
  highlightedId: string | null;
  onHoverCard: (id: string | null) => void;
  firstIsLcp: boolean;
}) {
  return (
    <ul className="ph-no-capture @container mx-auto w-full max-w-[100rem] divide-y divide-border-subtle px-4 @3xl:px-8">
      {cards.map((card, index) => (
        <li
          key={card.id}
          data-highlighted={card.id === highlightedId ? "" : undefined}
          className={cn("min-w-0", "data-[highlighted]:bg-action-tint/40")}
          onMouseEnter={() => onHoverCard(card.id)}
          onMouseLeave={() => onHoverCard(null)}
          onFocus={() => onHoverCard(card.id)}
          onBlur={() => onHoverCard(null)}
        >
          <ProductListingRow display={card.card} priority={firstIsLcp && index === 0} />
        </li>
      ))}
    </ul>
  );
}
